import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { ReservationService } from 'src/app/services/reservation.service';
import * as moment from "moment-timezone";
const emails = require('../../services/emails.json');

@Component({
  selector: 'app-reserve-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ReserveConfirmComponent implements OnInit {
  reserveInfo: any;
  reservedNotificationTemplate: any;

  constructor(
    public auth: AuthService,
    private shared: SharedService,
    private rs: ReservationService
  ) {}

  async ngOnInit() {
    if (this.shared.getCookie(SharedService.CURRENT_RESERVE) === undefined) {
      this.shared.redirect('/rooms');
      return;
    }

    this.reserveInfo = this.shared.getCookie(SharedService.CURRENT_RESERVE);
    this.reservedNotificationTemplate = ReservationService.TEMPLATE_RESERVED
  }

  send() {
    let data = Object.assign({}, this.reserveInfo)
    delete data.vtuberPhoto
    delete data.vtuberName

    this.auth.toggleSpinner(true)

    this.rs.createReservation(data)
    .then(response => {
      let id = response.id

      data.uid = id
      this.rs.updateReservationData(data)

      let user = Object.assign({}, this.auth.user)
      if (user.active_reservations) {
        let hasAlready = false;
        user.active_reservations = user.active_reservations.map(item => {
          if (item.vtuber_uid === data.vtuber_uid) {
            item.count++;
            hasAlready = true;
          }
          
          return item;
        })

        if (hasAlready === false) {
          user.active_reservations.push({
            vtuber_uid: data.vtuber_uid,
            count: 1
          })
        }
      } else {
        user.active_reservations = [];
        user.active_reservations.push({
          vtuber_uid: data.vtuber_uid,
          count: 1
        })
      }

      if (user.plans) {
        user.plans = user.plans.map(item => {
          if (item.vtuber_id === data.vtuber_uid) item.used_period = parseInt(item.used_period) + parseInt(data.duration) * 1
          return item
        })
      }

      this.auth.updateUserData(user);
      this.auth.fetchUser();

      this.auth.getUserByUid(data.vtuber_uid).subscribe(res => {
          if (res && res.length > 0) {
            let vtuber: any = res[0]

            let start = parseInt(data.start.split(':')[0]) * 60 + parseInt(data.start.split(':')[1]);
            let end = parseInt(data.end.split(':')[0]) * 60 + parseInt(data.end.split(':')[1]);
            
            vtuber.events = vtuber.events.map(item => {
                if (item.uid === data.event_uid) {
                    item.hasArrangement = true
                    item.reservations = item.reservations ? item.reservations : []
                    item.reservations.push({
                      reservation_id: id,
                      start: start,
                      end: end % 5 === 0 ? end + 10 : (Math.floor(end / 5) * 5) + 15
                    })
                }
                return item
            })

            this.auth.updateUserData(vtuber)

            if (this.reservedNotificationTemplate) {
              this.reservedNotificationTemplate = this.reservedNotificationTemplate.replace("{{time}}", this.shared.getReserveTime(this.reserveInfo))
              this.rs.sendNotification(this.auth.user.uid, vtuber.uid, this.reservedNotificationTemplate)
            }

            this.auth.sendEmail({
              to: vtuber.email,
              subject: emails.reserve_time_subject,
              text: this.auth.getEmailTemplate(emails.reserve_time.join("")).replace(/\[VTuber名\]/g, vtuber.displayName)
                                  .replace(/\[支援者名\]/g, this.auth.user.displayName)
                                  .replace(/\[通話予約の日時\]/g, moment(data.reserveAt).format("Y年MM月DD日 ") + data.start + " ~ " + data.end)
                                  .replace(/\[通話予約内容\]/g, data.message)
            })
          }

          let self = this
          setTimeout(function() {
            self.auth.toggleSpinner(false)
            self.shared.redirect("/reserve/list")
          }, 500)
      })
    })
    
  }
}
